import { useEffect, useState } from 'react';
import { PostUtil } from 'src/pages/new-post-new/post-util';
import TwitterPostImagesPreview from './twitter-post-images-preview.component';
import TwitterPostVideoPreview from './twitter-post-video-preview.component';

const TwitterPostPreview = ({ data }) => {
  const [isVideo, setIsVideo] = useState(false);
  useEffect(() => {
    if (!data) return;
    if (data?.media_data?.count == 1 && data?.media_data.media_data[0].type === PostUtil.MediaType.VIDEO) {
      setIsVideo(true);
    }
  }, [data]);
  return <>{isVideo ? <TwitterPostVideoPreview data={data} /> : <TwitterPostImagesPreview data={data} />}</>;
};

export default TwitterPostPreview;
